import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.5 16V22M12.5 22L15 19.5M12.5 22L10 19.5M12.5 9V3M12.5 3L15 5.5M12.5 3L10 5.5M16 12.5H22M22 12.5L19.5 15M22 12.5L19.5 10M9 12.5H3M3 12.5L5.5 15M3 12.5L5.5 10",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }